import { render } from "./CryptoPrice.vue?vue&type=template&id=a4ca93e0&scoped=true"
import script from "./CryptoPrice.vue?vue&type=script&lang=js"
export * from "./CryptoPrice.vue?vue&type=script&lang=js"

import "./CryptoPrice.vue?vue&type=style&index=0&id=a4ca93e0&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4ca93e0"]])

export default __exports__